import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormikField } from "@air/formik-field";
import { Button } from "@air/primitive-button";
import { Input } from "@air/primitive-input";
import { getLoginValidationSchema } from "@air/utils-auth";
import { Formik } from "formik";
import Form from "~/components/Form";
import PasswordInput from "~/components/Form/PasswordInput";
import { LOGIN_EMAIL_INPUT, LOGIN_PASSWORD_INPUT, LOGIN_SUBMIT_BUTTON } from "~/constants/testIDs";
import { PASSWORD_REQS_STRING } from "~/utils/Auth";
import { sanitizeEmail } from "~/utils/EmailUtils";
const _loginValidationSchema = getLoginValidationSchema();
export const LoginForm = (param)=>{
    let { loginUser, onError, disabled = false, existingEmail, children } = param;
    const LoginFormValidationSchema = getLoginValidationSchema(existingEmail);
    return /*#__PURE__*/ _jsx(Formik, {
        validateOnMount: true,
        initialValues: LoginFormValidationSchema.cast({}),
        validationSchema: LoginFormValidationSchema,
        onSubmit: async (values, param)=>{
            let { setSubmitting } = param;
            const emailValue = sanitizeEmail(values.email);
            try {
                setSubmitting(true);
                await loginUser(emailValue, values.password);
            } catch (error) {
                onError(emailValue, error);
            } finally{
                setSubmitting(false);
            }
        },
        children: (formikProps)=>/*#__PURE__*/ _jsxs(Form, {
                children: [
                    /*#__PURE__*/ _jsx(FormikField, {
                        className: "mb-4",
                        component: /*#__PURE__*/ _jsx(Input, {
                            type: "email",
                            autoComplete: "username",
                            "data-testid": LOGIN_EMAIL_INPUT,
                            disabled: disabled,
                            defaultValue: existingEmail,
                            size: "large"
                        }),
                        label: "Email *",
                        name: "email",
                        id: "email"
                    }),
                    /*#__PURE__*/ _jsx(PasswordInput, {
                        description: PASSWORD_REQS_STRING,
                        size: "large",
                        className: "mb-4",
                        testId: LOGIN_PASSWORD_INPUT,
                        disabled: disabled
                    }),
                    children ? children(formikProps) : /*#__PURE__*/ _jsx(Button, {
                        type: "submit",
                        className: "mt-12 w-full",
                        appearance: "filled",
                        color: "blue",
                        size: "large",
                        isLoading: formikProps.isSubmitting,
                        "data-testid": LOGIN_SUBMIT_BUTTON,
                        disabled: disabled || formikProps.isSubmitting,
                        children: "Log in"
                    })
                ]
            })
    });
};
